import { ModuleChargeModel, ModuleModel, PackageModuleDetailModel, PackageModuleModel, PackageModuleViewModel, PackageType } from "@admin/masters/pages/package-modules/models";
import { Component, OnDestroy, OnInit, TemplateRef, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ApiResources, UtilHelper } from "@shared/helpers";
import { IResource, IUserAccount, Page, Pagination } from "@shared/models";
import { AppData, HttpService, NotifyService, ResourceService } from "@shared/services";
import { finalize, takeUntil } from "rxjs/operators";
import Swal from "sweetalert2";

class TrackBy {
    moduleCharge(_: number, item: ModuleChargeModel): number {
        return item.referenceId;
    }

    module(_: number, item: ModuleModel): number {
        return item.modulesMasterId;
    }
}
class FilterOptions {
    chargeName: string = null ;
    chargeGroupname: string = null;
    serviceDepartmentName: string = null;
}

class Filters {
    options: FilterOptions;
    applied: boolean;

    constructor() {
        this.init();
    }

    init() {
        this.options = new FilterOptions();
        this.applied = undefined;
    }
}

interface ICharge {
    module: ModuleModel;
    moduleCharges: Array<ModuleChargeModel>;
}

@Component({
    templateUrl: "./modify-package-module.html",
    selector: "modify-package-module",
    encapsulation: ViewEncapsulation.None
})
export class ModifyPackageModulePage implements OnInit, OnDestroy {
    packageType = PackageType;
    filters: Filters;
    page: Page;
    trackBy: TrackBy;
    loadingPackageInfo: boolean;
    packageMouduleId: string;
    packageInfo: PackageModuleViewModel;
    loadingLocations: boolean;
    locations: Array<IResource>;
    loadingProviders: boolean;
    providers: Array<IResource>;
    loadingPackageTypes: boolean;
    packageTypes: Array<IResource>;
    loadingModuleTypes: boolean;
    moduleTypes: Array<IResource>;
    loadingChargeCategories: boolean;
    chargeCategories: Array<IResource>;
    loadingModules: boolean;
    modules: Array<ModuleModel>;
    showRepeatType: boolean;
    loadingModuleCharges: boolean;
    moduleCharges: Array<ModuleChargeModel>;
    moduleChargePushArray: Array<ModuleChargeModel>;
    selectedModule: ModuleModel;
    charges: Array<ICharge>;
    packageForm: FormGroup;
    isSubmitted: boolean;
    isSubmitting: boolean;
    pagination: Pagination;
    private modalRef: NgbModalRef;
    private packageModule: PackageModuleModel;
    private packageModuleDetails: Array<PackageModuleDetailModel>;
    moduleId: string = null;

    consentForms: Array<IResource>;
    loadingConsentForms: boolean;

    constructor(
        private readonly router: Router,
        private readonly appData: AppData,
        private readonly route: ActivatedRoute,
        private readonly modalService: NgbModal,
        private readonly httpService: HttpService,
        private readonly formBuilder: FormBuilder,
        private readonly notifyService: NotifyService,
        private readonly resourceService: ResourceService
    ) {
        this.page = new Page();
        this.trackBy = new TrackBy();
        this.charges = [];
        this.loadingPackageInfo = true;
        this.initPagination();
        this.filters = new Filters();
        this.moduleChargePushArray = new Array<ModuleChargeModel>();
    }

    ngOnInit(): void {
        this.setUserAccount();
        this.findPackageIdFromRoute();
        this.fetchLocations();
        this.fetchPackageTypes();
        this.fetchModuleTypes();
        //this.fetchConsentForms();
    }

    onBack(): void {
        this.router.navigateByUrl("/app/masters/package-modules");
    }

    get form() {
        return this.packageForm.controls;
    }

    onAddModule(module: ModuleModel): void {
        let isInValid = false;
        if (module && module.modulesMasterId > 0)
            if (module.packageType)
                if (module.isChargeCategoryApplicable || module.isPackageApplicable)
                    if ([PackageType.SingleSelect, PackageType.MultiSelect].includes(module.packageType as PackageType))
                        this.assignCharges(module);
                    else {
                        this.notifyService.warningToast("This module cannot be chosen because it should have a package type of 'S' or 'M'.");
                        isInValid = true;
                    }
                else
                    if ([PackageType.Limit, PackageType.Quantity].includes(module.packageType as PackageType))
                        this.assignCharges(module);
                    else {
                        this.notifyService.warningToast("This module cannot be chosen because it should have a package type of 'L' or 'Q'");
                        isInValid = true;
                    }
            else {
                this.notifyService.warningToast("A module without 'Package Type' cannot be added.");
                isInValid = true;
            }

        if (isInValid) {
            const modules = this.packageForm.get("modules").value as Array<ModuleChargeModel>;
            modules.splice(modules.findIndex(m => m.modulesMasterId === module.modulesMasterId), 1);
            this.packageForm.get("modules").setValue(modules);
        }
    }

    onRemoveModule(module: ModuleModel): void {
        const index = this.charges.findIndex(m => m.module.modulesMasterId === module.modulesMasterId);
        if (index !== -1) {
            this.charges.splice(index, 1);
            this.calcTotal();
        }
    }

    onOpenModal(content: TemplateRef<any>, module: ModuleModel): void {
        this.selectedModule = module;
        this.moduleChargePushArray = new Array<ModuleChargeModel>();
        this.fetchModuleCharges(module.modulesMasterId.toString());
        this.modalRef = this.modalService.open(content, { size: "xl", windowClass: "custom-modal modal-dialog-scrollable", centered: true, backdrop: "static", keyboard: false });
    }

    onSelectCharge(moduleCharge: ModuleChargeModel, event: Event): void {
        const isSelected = (event.currentTarget as HTMLInputElement).checked;
        if (isSelected) {
            if (this.selectedModule.packageType === this.packageType.SingleSelect) {
                this.resetSelectedModuleCharges();
                moduleCharge.quantity = 1;
                moduleCharge.isSelected = true;
            }
            moduleCharge.quantity = 1;
            moduleCharge.isSelected = true;
            this.moduleChargePushArray.push(moduleCharge);
        } else {
            moduleCharge.quantity = null;
            moduleCharge.isSelected = false;
            moduleCharge.isFree = false;
            this.moduleChargePushArray.forEach((item, index) => {
                if (item.referenceId == moduleCharge.referenceId) this.moduleChargePushArray.splice(index, 1);
            });
        }
    }

    onSelectFree(moduleCharge: ModuleChargeModel, event: Event): void {
        const isSelected = (event.currentTarget as HTMLInputElement).checked;
        if (isSelected) {
            if (this.selectedModule.packageType === this.packageType.SingleSelect)
                this.resetSelectedModuleCharges();
            moduleCharge.quantity = 1;
            moduleCharge.isSelected = true;
            const checkIfAll = this.moduleChargePushArray.find(m => m.modulesMasterId === moduleCharge.modulesMasterId && m.referenceId === moduleCharge.referenceId);
            if (checkIfAll) checkIfAll.isFree = true;
            if (checkIfAll == undefined || checkIfAll == null) this.moduleChargePushArray.push(moduleCharge);
        }
    }

    onCloseModal(): void {
        if (this.modalRef) {
            this.modalRef.close();
            this.modalRef = undefined;
        }
        this.filters.init();
        this.selectedModule = undefined;
        this.loadingModuleCharges = undefined;
        this.showRepeatType = undefined;
        this.moduleCharges = undefined;
        this.moduleChargePushArray.splice(0);
    }

    onSubmitCharges(): void {
        const selectedCharges = this.moduleChargePushArray.filter(m => m.isSelected);
        //const selectedCharges = this.moduleCharges.filter(m => m.isSelected);
        if (!selectedCharges || !selectedCharges.length) {
            alert("Please select charges");
            return;
        }

        const charge = this.charges.find(m => m.module.modulesMasterId === this.selectedModule.modulesMasterId);
        if (charge) {
            charge.moduleCharges = selectedCharges;
        } else {
            this.charges.push({
                module: this.selectedModule,
                moduleCharges: selectedCharges
            } as ICharge);
        }

        this.calcTotal();
        this.onCloseModal();
    }

    onChangePackageType(item: IResource): void {
        const packageTypeName = this.packageForm.get("packageTypeName");
        if (item) {
            packageTypeName.setValue(item.name);
        } else {
            packageTypeName.setValue(null);
        }
    }

    onChangeModuleType(item: IResource): void {
        const moduleTypeName = this.packageForm.get("moduleTypeName");
        if (item) {
            moduleTypeName.setValue(item.name);
        } else {
            moduleTypeName.setValue(null);
        }
    }

    onChangeModelValue(module: ModuleModel): void {
        const modelValue = module.modelValue;
        if (!modelValue) return;

        let charge: ICharge;
        if (this.charges && this.charges.length)
            charge = this.charges.find(m => m.module.modulesMasterId === module.modulesMasterId);

        const amount = module.packageType === this.packageType.Limit ? modelValue : 0;
        if (charge) {
            if (charge.moduleCharges && charge.moduleCharges.length) {
                charge.moduleCharges[0].quantity = module.packageType === this.packageType.Quantity ? modelValue : 1;
                charge.moduleCharges[0].isFree = false;
                charge.moduleCharges[0].amount = amount;
            } else {
                charge.moduleCharges = [{
                    modulesMasterId: module.modulesMasterId,
                    quantity: module.packageType === this.packageType.Quantity ? modelValue : 1,
                    isFree: false,
                    amount: amount
                } as ModuleChargeModel];
            }
        }
        else {
            this.charges.push({
                module: module,
                moduleCharges: [{
                    modulesMasterId: module.modulesMasterId,
                    quantity: module.packageType === this.packageType.Quantity ? modelValue : 1,
                    amount: amount,
                    isFree: false
                }]
            } as ICharge);
        }

        this.calcTotal();
    }

    filterModuleCharges(modulesMasterId: number): Array<ModuleChargeModel> {
        const module = this.charges.find(m => m.module.modulesMasterId === modulesMasterId);
        return module && module.moduleCharges || [];
    }

    onRemoveCharge(modulesMasterId: number, index: number): void {
        const moduleCharges = this.filterModuleCharges(modulesMasterId);
        moduleCharges.splice(index, 1);
        this.calcTotal();
    }

    onSubmit(): void {
        this.isSubmitted = true;
        if (this.packageForm.invalid) return;

        // When No Charges
        if (!this.charges || !this.charges.length || !this.charges.map(m => m.moduleCharges).length) {
            this.notifyService.warning("To save package details, please add some charges.");
            return;
        }

        const formData = this.packageForm.getRawValue();

        // When No Charges Assigned to a selected module
        let errorModules = [];
        (formData.modules as Array<ModuleModel>).forEach((m: ModuleModel) => {
            let charges = this.filterModuleCharges(m.modulesMasterId);
            if (!charges.length) errorModules.push(m.moduleName);
        });

        if (errorModules.length) {
            this.notifyService.warning(`To save package details, please add some charges for the chosen '${errorModules.join(", ")}' module${errorModules.length > 1 ? 's' : ''}.`);
            return;
        }

        const requestBody = {
            packageModule: {
                packageModuleId: formData.packageModuleId,
                locationId: formData.location.id,
                providerId: formData.provider && formData.provider.id ? formData.provider.id : null,
                packageName: formData.packageName,
                packageTypeId: formData.packageTypeId,
                moduleTypeId: formData.moduleTypeId,
                chargeModuleTemplateId: formData.chargeTemplate.id,
                modulesMasterIds: formData.modules.map((m: ModuleModel) => m.modulesMasterId).join(","),
                notes: formData.notes,
                exclusions: formData.exclusions,
                freeQuantity: formData.freeQuantity,
                quantity: formData.quantity,
                expiresIn: formData.expiresIn,
                userAccountId: this.page.userAccount.accountId,
                discountType: formData.discountType,
                discountPercentage: formData.discountPercentage,
                discountAmount: formData.discountAmount,
                createdBy: this.page.userAccount.accountId,
                createdByName: this.page.userAccount.fullName,
                modifiedBy: this.page.userAccount.accountId,
                modifiedByName: this.page.userAccount.fullName,
                loginRoleId: this.page.userAccount.roleId,
                comments: formData.comments,
                consentFormsIds: formData.consentForms.map((m: IResource) => m.id).join(","),
            },
            packageDetails: []
        }

        const modulesMasterIds = [], errors = [];
        this.charges.forEach((m: ICharge) => {
            if (!m.module.isChargeCategoryApplicable && !m.module.isPackageApplicable) {
                if (m.module.modelValue && m.moduleCharges && m.moduleCharges.length) {
                    modulesMasterIds.push(m.module.modulesMasterId);
                    const item = m.moduleCharges[0];
                    requestBody.packageDetails.push({
                        packageModuleId: formData.packageModuleId,
                        modulesMasterId: m.module.modulesMasterId,
                        packageModuleDetailId: item.packageModuleDetailId,
                        userAccountId: this.page.userAccount.accountId,
                        quantity: item.quantity,
                        amount: item.amount,
                        isFree: item.isFree
                    });
                }
                else
                    errors.push(`Please add value for ${m.module.moduleName}.`);
            } else {
                if (m.moduleCharges && m.moduleCharges.length) {
                    modulesMasterIds.push(m.module.modulesMasterId);
                    m.moduleCharges.forEach((cd: ModuleChargeModel) => {
                        requestBody.packageDetails.push({
                            packageModuleId: formData.packageModuleId,
                            referenceId: cd.referenceId,
                            modulesMasterId: cd.modulesMasterId,
                            packageModuleDetailId: cd.packageModuleDetailId,
                            userAccountId: this.page.userAccount.accountId,
                            quantity: cd.quantity,
                            amount: cd.amount,
                            isFree: cd.isFree
                        });
                    });
                }
                else
                    errors.push(`Please add some charges for ${m.module.moduleName} or remove the module from charge modules.`);
            }
        });

        if (errors && errors.length) {
            this.notifyService.warning(errors.join("<br/>"));
            return;
        }

        requestBody.packageModule.modulesMasterIds = modulesMasterIds.join(",");

        this.isSubmitting = true;
        this.httpService
            .post(ApiResources.getURI(ApiResources.packageModule.base, ApiResources.packageModule.modify), requestBody)
            .pipe(finalize(() => { this.isSubmitting = false; this.isSubmitted = false }), takeUntil(this.page.unSubscribe))
            .subscribe({
                next: (response: number) => {
                    if (response > 0) {
                        this.notifyService.successToast(`Package module ${requestBody.packageModule.packageModuleId > 0 ? 'updated' : 'added'} successfully.`);
                        this.onBack();
                    }
                    else if (response === -1) {
                        this.notifyService.warningToast("This Package Name  already exists.");
                        return;
                    }
                    else {
                        this.notifyService.defaultError()
                    }

                }
            });
    }

    ngOnDestroy(): void {
        this.page.unsubscribeAll();
        Swal.close()
    }

    private findPackageIdFromRoute(): void {
        this.route.params
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe(params => {
                const packageMouduleId = params["id"];
                if (packageMouduleId) {
                    this.packageMouduleId = packageMouduleId;
                    this.findPackageInfo();
                } else {
                    this.loadingPackageInfo = false;
                    this.buildForm();
                }
            });
    }

    private findPackageInfo(): void {
        this.loadingPackageInfo = true;
        this.httpService
            .get(ApiResources.getURI(ApiResources.packageModule.base, ApiResources.packageModule.find), { id: this.packageMouduleId })
            .pipe(finalize(() => this.loadingPackageInfo = false), takeUntil(this.page.unSubscribe))
            .subscribe({
                next: (response: PackageModuleViewModel) => {
                    if (response && response.packageModule && response.packageModuleDetails && response.packageModuleDetails.length) {
                        this.packageInfo = response;
                        this.packageModule = response.packageModule;
                        this.packageModuleDetails = response.packageModuleDetails;
                        this.buildForm();
                    }
                },
                error: () => this.packageInfo = undefined
            });
    }

    private setUserAccount(): void {
        this.appData.userAccount
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((userAccount: IUserAccount) => this.page.userAccount = userAccount || undefined);
    }

    private fetchLocations(): void {
        this.loadingLocations = true;
        this.httpService
            .get(ApiResources.getURI(ApiResources.packageModule.base, ApiResources.packageModule.fetchLocations), {})
            .pipe(finalize(() => this.loadingLocations = false), takeUntil(this.page.unSubscribe))
            .subscribe({
                next: (response: Array<IResource>) => this.locations = response,
                error: () => this.locations = []
            });
    }

    private fetchPackageTypes(): void {
        this.loadingPackageTypes = true;
        this.resourceService.packageTypes()
            .pipe(finalize(() => this.loadingPackageTypes = false), takeUntil(this.page.unSubscribe))
            .subscribe({
                next: (response: Array<IResource>) => this.packageTypes = response,
                error: () => this.packageTypes = []
            });
    }

    private fetchModuleTypes(): void {
        this.loadingModuleTypes = true;
        this.resourceService.moduleTypes()
            .pipe(finalize(() => this.loadingModuleTypes = false), takeUntil(this.page.unSubscribe))
            .subscribe({
                next: (response: Array<IResource>) => this.moduleTypes = response,
                error: () => this.moduleTypes = []
            });
    }

    private fetchProviders(locationId: number): void {
        this.loadingProviders = true;
        this.httpService
            .get(ApiResources.getURI(ApiResources.resources.base, ApiResources.resources.providerAccountLocationMap), { location: { locationId } })
            .pipe(finalize(() => this.loadingProviders = false), takeUntil(this.page.unSubscribe))
            .subscribe({
                next: (response: Array<IResource>) => this.providers = response,
                error: () => this.providers = []
            });
    }

    private fetchChargeCategories(chargeModuleTemplateId: number): void {
        this.loadingChargeCategories = true;
        this.httpService
            .get(ApiResources.getURI(ApiResources.packageModule.base, ApiResources.packageModule.fetchChargeCategories), { chargeModuleTemplateId })
            .pipe(finalize(() => this.loadingChargeCategories = false), takeUntil(this.page.unSubscribe))
            .subscribe({
                next: (response: Array<IResource>) => this.chargeCategories = response,
                error: () => this.chargeCategories = []
            });
    }

    private fetchModules(chargeModuleTemplateId: number): void {
        this.loadingModules = true;
        this.httpService
            .get(ApiResources.getURI(ApiResources.packageModule.base, ApiResources.packageModule.fetchModules), { chargeModuleTemplateId })
            .pipe(finalize(() => this.loadingModules = false), takeUntil(this.page.unSubscribe))
            .subscribe({
                next: (response: Array<ModuleModel>) => {
                    this.modules = response;
                    if (this.packageModule && this.packageModule.modulesMasterIds) {
                        const modulesMasterIds = this.getIds(this.packageModule.modulesMasterIds);
                        const modules = this.modules.filter(m => modulesMasterIds.includes(m.modulesMasterId));
                        this.packageForm.get("modules").setValue(modules);

                        modules.forEach((module: ModuleModel) => {
                            this.assignCharges(module);
                        });

                        this.calcTotal();
                    } else {
                        this.packageForm.get("modules").setValue(null);
                    }
                },
                error: () => this.modules = []
            });
    }

    private fetchModuleCharges(modulesMasterId: string): void {
        this.loadingModuleCharges = true;
        this.moduleId = modulesMasterId;

        this.httpService
            .get(ApiResources.getURI(ApiResources.packageModule.base, ApiResources.packageModule.fetchModuleCharges), {
                modulesMasterIds: modulesMasterId, locationId: this.form.location.value.id, pageSize: this.pagination.pageSize, pageIndex: this.pagination.pageIndex, chargeName: this.filters.options.chargeName,
                ChargeGroupname: this.filters.options.chargeGroupname, ServiceDepartmentName: this.filters.options.serviceDepartmentName })
            .pipe(finalize(() => this.loadingModuleCharges = false), takeUntil(this.page.unSubscribe))
            .subscribe({
                next: (charges: Array<ModuleChargeModel>) => {
                    if (charges !== null && charges.length > 0) {
                        charges.forEach((item) => {
                            const selected2 = this.moduleChargePushArray.find(m => m.modulesMasterId === item.modulesMasterId && m.referenceId === item.referenceId);
                            if (selected2) {
                                item.isSelected = true;
                                item.quantity = selected2.quantity;
                                item.isFree = selected2.isFree;
                            }
                        });
                        const selectedCharges = this.filterModuleCharges(charges[0].modulesMasterId);
                        if (selectedCharges && selectedCharges.length) {
                            charges.forEach(function (item) {
                                const selected = selectedCharges.find(m => m.modulesMasterId === item.modulesMasterId && m.referenceId === item.referenceId);
                                if (selected) {
                                    item.isSelected = true;
                                    item.quantity = selected.quantity;
                                    item.isFree = selected.isFree;
                                    //this.moduleChargePushArray.push(item);
                                }
                            });
                        }

                    }

                    this.moduleCharges = charges;
                    UtilHelper.applyPagination(this.moduleCharges, this.pagination);
                    if (charges && charges.length)
                        this.showRepeatType = charges[0].repeatTypeId > 0;
                },
                error: () => this.moduleCharges = []
            });
    }

    private assignCharges(module: ModuleModel): void {
        let charges: Array<ModuleChargeModel>;
        if (this.packageModuleDetails && this.packageModuleDetails.length) {
            charges = this.packageModuleDetails
                .filter(m => m.modulesMasterId === module.modulesMasterId)
                .map(m => {
                    const item = new ModuleChargeModel();
                    item.packageModuleDetailId = m.packageModuleDetailId;
                    item.chargeGroupId = m.chargeGroupId;
                    item.chargeGroupName = m.chargeGroupName;
                    item.modulesMasterId = m.modulesMasterId;
                    item.chargeName = m.chargeName;
                    item.departmentId = m.departmentId;
                    item.departmentName = m.departmentName;
                    item.isFree = m.isFree;
                    item.amount = m.amount;
                    item.isSelected = true;
                    item.locationId = m.locationId;
                    item.moduleIcon = m.moduleIcon;
                    item.moduleName = m.moduleName;
                    item.modulesMasterId = m.modulesMasterId;
                    item.quantity = m.quantity;
                    item.referenceId = m.referenceId;
                    item.repeatTypeId = m.repeatTypeId;
                    item.repeatTypeName = m.repeatTypeName;
                    return item;
                });

            if (module.packageType === this.packageType.Limit)
                module.modelValue = this.packageModuleDetails.filter(m => m.modulesMasterId === module.modulesMasterId)[0].amount;

            if (module.packageType === this.packageType.Quantity)
                module.modelValue = this.packageModuleDetails.filter(m => m.modulesMasterId === module.modulesMasterId)[0].quantity;

            const existingModule = this.charges.find(m => m.module.modulesMasterId === module.modulesMasterId);
            if (existingModule && existingModule.module) {
                existingModule.module = module;
                existingModule.moduleCharges = charges;
            } else {
                this.charges.push({
                    module: module,
                    moduleCharges: charges
                } as ICharge);
            }
        }
    }

    private getIds(value: string): Array<number> {
        if (value.indexOf(",") > -1)
            return value.split(",").map(m => parseInt(m));
        else
            return [parseInt(value)];
    }

    private resetSelectedModuleCharges(): void {
        this.moduleChargePushArray.forEach((item: ModuleChargeModel) => {
            item.isSelected = false;
            item.isFree = false;
            item.quantity = null;
        });
        //this.moduleCharges.forEach((item: ModuleChargeModel) => {
        //    item.isSelected = false;
        //    item.isFree = false;
        //    item.quantity = null;
        //});
    }

    private setDiscountControls(discountType: string, updateValue: boolean): void {
        const discountPercentage = this.packageForm.get("discountPercentage");
        const discountAmount = this.packageForm.get("discountAmount");

        if (updateValue) {
            discountPercentage.setValue(null);
            discountAmount.setValue(null);
        }

        if (discountType === "P") {
            discountPercentage.setValidators([Validators.required]);
            discountAmount.clearValidators();

        } else if (discountType === "A") {
            discountAmount.setValidators([Validators.required]);
            discountPercentage.clearValidators();
        } else {
            discountPercentage.clearValidators();
            discountAmount.clearValidators();
        }

        discountPercentage.updateValueAndValidity();
        discountAmount.updateValueAndValidity();
    }

    private buildForm(): void {
        this.packageForm = this.formBuilder.group({
            packageModuleId: this.packageModule && this.packageModule.packageModuleId || 0,
            packageName: [this.packageModule && this.packageModule.packageName || null, [Validators.required]],
            packageTypeId: [this.packageModule && this.packageModule.packageTypeId || null, [Validators.required]],
            packageTypeName: this.packageModule && this.packageModule.packageTypeName || null,
            moduleTypeId: [this.packageModule && this.packageModule.moduleTypeId || null, [Validators.required]],
            moduleTypeName: this.packageModule && this.packageModule.moduleTypeName || null,
            location: [null, [Validators.required]],
            provider: null,
            chargeTemplate: [null, [Validators.required]],
            modules: [[], [Validators.required]],
            notes: this.packageModule && this.packageModule.notes || null,
            exclusions: this.packageModule && this.packageModule.exclusions || null,
            freeQuantity: this.packageModule && this.packageModule.freeQuantity || null,
            quantity: this.packageModule && this.packageModule.quantity || null,
            expiresIn: this.packageModule && this.packageModule.expiresIn || null,
            discountType: this.packageModule && this.packageModule.discountType || null,
            discountPercentage: this.packageModule && this.packageModule.discountPercentage || null,
            discountAmount: this.packageModule && this.packageModule.discountAmount || null,
            comments: this.packageModule && this.packageModule.comments || null,
            consentForms: [],
        });

        if (this.packageModule && this.packageModule.discountType)
            this.setDiscountControls(this.packageModule.discountType, false);

        if (this.packageModule && this.packageModule.locationId) {
            setTimeout(() => {
                if (this.locations && this.locations.length) {
                    const location = this.locations.find(m => m.id === this.packageModule.locationId);
                    this.packageForm.get("location").setValue(location);
                }
            }, 500);
        }

        this.packageForm.get("location").valueChanges
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((location: IResource) => {
                if (location && location.id) {
                    this.fetchProviders(location.id);
                    this.packageForm.get("chargeTemplate").setValue({ id: location.optionalId, name: location.optionalText });
                }
                else {
                    this.providers = [];
                    this.packageForm.get("provider").setValue(null);
                    this.packageForm.get("chargeTemplate").setValue(null);
                }
            });

        this.packageForm.get("chargeTemplate").valueChanges
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((chargeTemplate: IResource) => {
                this.resetCharges();
                if (chargeTemplate && chargeTemplate.id) {
                    this.fetchModules(chargeTemplate.id);
                    this.fetchChargeCategories(chargeTemplate.id);
                    this.fetchConsentForms();
                }
            });

        this.packageForm.get("discountType").valueChanges
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((discountType: string) => this.setDiscountControls(discountType, true));
    }

    private resetCharges(): void {
        this.chargeCategories = [];
        this.modules = [];
        this.charges = [];
        this.packageForm.get("modules").setValue([]);
    }

    private calcTotal(): void {
        let freeQuantity = 0, quantity = 0;
        if (this.charges && this.charges.length > 0) {
            this.charges.forEach((item: ICharge) => {
                item.moduleCharges.forEach(charge => {
                    if (!charge.isFree)
                        quantity += charge.quantity;
                    else {
                        freeQuantity += charge.quantity;
                        quantity += charge.quantity;
                    }
                });
            });
        }

        this.packageForm.get("quantity").setValue(quantity);
        this.packageForm.get("freeQuantity").setValue(freeQuantity ? freeQuantity : null);
    }

    private initPagination() {
        this.pagination = new Pagination();
        this.pagination.pageIndex = 1;
        this.pagination.pageSize = 15;
    }

    onNextPage(module: ModuleModel) {
        this.fetchModuleCharges(module.modulesMasterId.toString());
    }
    onServiceResetFilters() {
        this.filters.init();
        this.initPagination();
        this.fetchModuleCharges(this.moduleId);
    }
    onServiceFilters() {
        this.initPagination();
        this.fetchModuleCharges(this.moduleId);
    }


    private fetchConsentForms(): void {
        this.loadingConsentForms = true;
        this.resourceService.consentForms()
            .pipe(finalize(() => this.loadingConsentForms = false), takeUntil(this.page.unSubscribe))
            .subscribe({
                next: (response: Array<IResource>) => {
                    this.consentForms = response
                    if (this.packageModule && this.packageModule.consentFormsIds) {
                        const consentFormIds = this.getIds(this.packageModule.consentFormsIds);
                        const consents = this.consentForms.filter(m => consentFormIds.includes(m.id));
                        this.packageForm.get("consentForms").setValue(consents);
                    } else {
                        this.packageForm.get("consentForms").setValue(null);
                    }
                },
                error: () => this.consentForms = []
            });
    }
    
}